import React__default from 'react';

var styles = {"container":"d76E4SH"};

/**
 * @deprecated Consider to use mantine
 */
const Container = ({ children, className, style, type }) => {
    return (React__default.createElement("div", { className: `${styles.container} ${className || ''}`, style: style, "data-type": type }, children));
};

export { Container as C };
